export default "__VITE_ASSET__0184a5c6__"